var config = {
    requestBaseUrl: "https://yun.chy12.com/",
    uploadFileBaseUrl: "https://yun.chy12.com/"
};

export default config;
